import React from 'react';
import { useTranslation } from 'react-i18next';
import { Delete, Edit, Restore } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { PRIVATE_USER_FORM_SERVICE_COMPANY, PRIVATE_USER_GESTION_DE_SERVICIOS, PRIVATE_USER_LIST_DELEGATION_SERVICE } from '../../../Constants/PathsConstants';
import { deleteServiceCompanyService } from 'DelegationService/DelegationService/Domain/Services/ServiceCompany/DeleteServiceCompanyService';
import { getServiceCompanyListService } from 'DelegationService/DelegationService/Domain/Services/ServiceCompany/GetServiceCompanyListService';
import { patchServiceCompanyService } from 'DelegationService/DelegationService/Domain/Services/ServiceCompany/PatchServiceCompanyService';
import Loader from 'UI/Application/Components/Loaders/Loader';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper, TextField, Grid, Typography, Pagination, DialogTitle, DialogActions, Dialog, DialogContent, Tooltip, IconButton, InputLabel } from '@mui/material';
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import { ClearIcon } from "@mui/x-date-pickers";
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { GESTOR_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';

function TableServiceCompanyView() {
    const { t } = useTranslation();
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    const [offset, setOffset] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [lastPage, setLastPage] = React.useState(1);
    const [ServiceCompany, setServiceCompanyService] = React.useState([]);
    const [loadServiceCompany, setLoadServiceCompany] = React.useState(true);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openRestoreModal, setOpenRestoreModal] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState(null);
    const [filterServiceCompanyName, setFilterServiceCompanyName] = React.useState('');
    const [filterServiceCompanyCIF, setFilterServiceCompanyCIF] = React.useState('');
    const [filterDeleted, setFilterDeleted] = React.useState(0);
    const navigate = useNavigate();
    const limit = 10;
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    console.log(hasAdminPermission);
    React.useEffect(() => {

        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);

        setHasAdminPermission(admin);

        if (!admin) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }
    }, [checkPermission, navigate]);

    const handleDelete = (id) => {
        setSelectedId(id);
        setOpenDeleteModal(true);
    };
    const handleConfirmDelete = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            deleteServiceCompanyService(selectedId).then(response => {
                if (response) {
                    setOpenDeleteModal(false);
                    setLoadServiceCompany(true);
                    setSelectedId(null);
                    toast.success(t("serviceCompany.table.modal.delete.done"));
                }
            }).finally(() => {
                setSendingApiRequest(false);
            });
        }
    };
    const handleRestore = (id) => {
        setSelectedId(id);
        setOpenRestoreModal(true);
    };

    const handleConfirmRestore = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            const serviceCompanyToRestore = ServiceCompany.find(a => a.id === selectedId);
            if (!serviceCompanyToRestore) {
                toast.error(t("serviceCompany.restore.error"));
                setSendingApiRequest(false);
                return;
            }
            patchServiceCompanyService(selectedId, {
                restore: true,
                ServiceCompanyName: serviceCompanyToRestore.ServiceCompanyName,
                ServiceCompanyCIF: serviceCompanyToRestore.ServiceCompanyCIF,
            }).then((response) => {
                if (response) {
                    setOpenRestoreModal(false);
                    setLoadServiceCompany(true);
                    setSelectedId(null);
                    toast.success(t("serviceCompany.table.modal.restore.done"));
                }
            }).catch(error => {
                console.error("Error en Patch: ", error);
                toast.error(t("serviceCompany.restore.error"));
            }).finally(() => {
                setSendingApiRequest(false);
            });
        }
    };

    const handleFilterDeletedChange = (event) => {
        setFilterDeleted(event.target.value);
        setLoadServiceCompany(true);
    };

    const handleFilterServiceCompanyNameChange = (event) => {
        setFilterServiceCompanyName(event.target.value);
        setLoadServiceCompany(true);
    };

    const handleFilterServiceCompanyCIFChange = (event) => {
        setFilterServiceCompanyCIF(event.target.value);
        setLoadServiceCompany(true);
    };

    const handlePageChange = (event, newPage) => {        
        setCurrentPage(newPage);
        setOffset((newPage - 1) * limit);
        setLoadServiceCompany(true);
    };
    React.useEffect(() => {
        if (loadServiceCompany) {
            getServiceCompanyListService({
                offset: offset,
                limit: limit,
                filterName: filterServiceCompanyName,
                filterCIF: filterServiceCompanyCIF,
                filterDeleted: filterDeleted,
            }).then((response) => {
                if (!response || !response.records) {
                    setServiceCompanyService([]);
                    return;
                }
                setServiceCompanyService(response.records);
                setLastPage(Math.ceil(response.total / limit));
                setLoadServiceCompany(false);
            });
        }
    }, [loadServiceCompany, offset, limit, filterServiceCompanyName, filterServiceCompanyCIF, filterDeleted]);




    return (
        <>
            <Paper
                sx={{
                    margin: 0,
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    width: "100%"
                }}
            >
                <Box display="flex" alignItems="center" mb={1} paddingTop={1} paddingLeft={1}>
                    <IconButton size="small" onClick={() => navigate(PRIVATE_USER_GESTION_DE_SERVICIOS)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="body2" sx={{ ml: 1, cursor: 'pointer' }} onClick={() => navigate(PRIVATE_USER_GESTION_DE_SERVICIOS)}>Volver</Typography>
                </Box>
                {/*<NavigationBreadcrumbs */}
                <Typography variant="h4" sx={{ mb: 2, textAlign: "center" }}>
                    {t('serviceCompany.table.title')}
                </Typography>
                <Box sx={{ p: 1, flex: 1 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('serviceCompanyService.table.filter_by_name')}
                                    variant='outlined'
                                    size='small'
                                    value={filterServiceCompanyName}
                                    onChange={handleFilterServiceCompanyNameChange}
                                    InputProps={{
                                        endAdornment: filterServiceCompanyName && (
                                            <IconButton onClick={() => setFilterServiceCompanyName('')}>
                                                <ClearIcon />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('serviceCompanyService.table.filter_by_name2')}
                                    variant='outlined'
                                    size='small'
                                    value={filterServiceCompanyCIF}
                                    onChange={handleFilterServiceCompanyCIFChange}
                                    InputProps={{
                                        endAdornment: filterServiceCompanyCIF && (
                                            <IconButton onClick={() => setFilterServiceCompanyCIF('')}>
                                                <ClearIcon />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item>
                            <FormControl sx={{ width: '250px' }}>
                                <InputLabel id="filter-deleted-label">
                                    {t('serviceCompany.table.filter_by_name_3')}
                                </InputLabel>
                                <Select
                                    labelId='filter-deleted-label'
                                    id='filter-deleted'
                                    label={t('serviceCompany.table.filter_by_name_3')}
                                    variant='outlined'
                                    size='small'
                                    value={filterDeleted}
                                    onChange={handleFilterDeletedChange}
                                >
                                    <MenuItem value={0}>{t('serviceCompanyService.filter_by_deleted_not_deleted')}</MenuItem>
                                    <MenuItem value={1}>{t('serviceCompanyService.table.filter_by_deleted_deleted')}</MenuItem>
                                    <MenuItem value={2}>{t('serviceCompanyService.table.filter_by_deleted_all')}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ display: "flex", justifyContent: 'flex-end', mb: 2, mr: 2 }}>
                    <Button
                        variant='contained'
                        component={RouterLink}
                        to={PRIVATE_USER_FORM_SERVICE_COMPANY + "/new"}
                        startIcon={<AddIcon />}
                        sx={{
                            backgroundColor: "green",
                            color: "white",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#008f39" }
                        }}
                    >
                        {t("serviceCompany.form.create")}
                    </Button>
                </Box>

                {/* 🔹 Tabla de Servicios de Compañia */}
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: "100%" }} aria-label="service Company table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#0492D4' }}>
                                <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                    {t('serviceCompany.table.name')}
                                </TableCell>
                                <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                    {t('serviceCompany.table.CIF')}
                                </TableCell>
                                <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                    {t('serviceCompany.table.actions')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loadServiceCompany ? (
                                <TableRow>
                                    <TableCell colSpan={3} align='center'>
                                        <Loader />
                                    </TableCell>
                                </TableRow>
                            ) : ServiceCompany.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={3} align='center'>
                                        {t('serviceCompany.table.no_data')}
                                    </TableCell>
                                </TableRow>
                            ) : (
                                //Acciones 
                                ServiceCompany.map((company) => (
                                    <TableRow key={company.id}>
                                        <TableCell align='center'>{company.name}</TableCell>
                                        <TableCell align='center'>{company.CIF}</TableCell>
                                        <TableCell align='center'>{company.deletedAt === null ? (
                                            <>
                                                <Tooltip title={t('seviceCompany.table.actions.edit')}>
                                                    <IconButton component={RouterLink} to={PRIVATE_USER_FORM_SERVICE_COMPANY + "/" + company.id}>
                                                        <Edit color="metal" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={t('serviceCompany.table.actions.delete')}>
                                                    <IconButton onClick={() => { handleDelete(company.id) }}>
                                                        <Delete color="error" />
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        ) : (
                                            <>
                                                <Tooltip title={t('serviceCompany.table.modal.restore.title')}>
                                                    <IconButton onClick={() => handleRestore(company.id)}>
                                                        <Restore color="success" />
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* 🔹 Paginacion*/}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Pagination count={lastPage} page={currentPage} onChange={handlePageChange} />
            </Box>
            {/* 🔹 Modal Para eliminar Servicios */}
            <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                <DialogTitle>{t('serviceCompany.table.modal.delete.title')}</DialogTitle>
                <DialogContent>
                    <Typography variant='body1'>{t('serviceCompany.table.modal.delete.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenDeleteModal(false)}>
                        {t('serviceCompany.table.modal.delete.button.cancel')}
                    </Button>
                    <Button variant='contained' color='error' onClick={handleConfirmDelete}>
                        {t('serviceCompany.table.modal.delete.button.delete')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openRestoreModal} onClose={() => setOpenRestoreModal(false)}>
                <DialogTitle>{t('serviceCompany.table.modal.restore.title')}</DialogTitle>
                <DialogContent>
                    <Typography variant='body1'>{t('serviceCompany.table.modal.restore.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenRestoreModal(false)}>
                        {t('serviceCompany.table.modal.restore.cancel')}
                    </Button>
                    <Button variant='contained' color='success' onClick={handleConfirmRestore}>
                        {t('serviceCompany.table.actions.restore')}
                    </Button>
                </DialogActions>
            </Dialog>
            <DialogLoader open={sendingApiRequest} />
        </>
    );
}

export default TableServiceCompanyView;
